import { DatabaseEyeOffOutlineIcon } from './DatabaseEyeOffOutlineIcon';

/**
 * author: Michael Irigoyen
 * id F80F0F20-77A0-426B-9354-D6F5C2B77473
 * name database-eye-off-outline
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/database-eye-off-outline.svg
 * tags
 * - Database 
 */
export const DatabaseViewOffOutlineIcon = DatabaseEyeOffOutlineIcon;
export default DatabaseViewOffOutlineIcon